export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://storage.readdy-site.link/project_files/40beaa0c-0771-4602-8ee6-3d7ae94a03c5/0fea0a98-bfc8-477c-9bea-3c5b5cba818d_compressed_blueimpalus.webp"
        alt="Blue Impulse formation flight"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/55"></div>

      <div className="relative z-10 w-full flex flex-col items-center px-4 md:px-6 text-center">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-wide mb-2 animate-fade-in-up animate-delay-100">
          unicloud
        </h1>
        <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-white/90 mb-3 animate-fade-in-up animate-delay-200">
          池川尚樹
        </p>
        <p className="font-heading text-xl md:text-2xl lg:text-3xl text-white/80 italic mb-5 animate-fade-in-up animate-delay-300">
          人と技術をつなぐ
        </p>
      </div>

      <a
        href="#links"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-white/50 hover:text-white/80 transition-colors cursor-pointer animate-fade-in animate-delay-600"
      >
        <span className="text-xs font-label tracking-widest">SCROLL</span>
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-sm"></i>
        </div>
      </a>
    </section>
  );
}